export const GetFbAuthScope = (
  target?: "WHATSAPP" | "INSTAGRAM" | "FACEBOOK",
) => {
  const enableInsiderPermission = window.location.href.includes("isInsider");
  const insiderPermission =
    "ads_management,business_management,leads_retrieval";
  const instagramPermission =
    "instagram_manage_comments,instagram_basic,instagram_manage_messages";
  const whatsapp = "whatsapp_business_management,business_management";
  // const whatsapp = "whatsapp_business_management,whatsapp_business_messaging";
  let scopeString = `public_profile,pages_show_list,pages_messaging,ads_read,pages_manage_metadata,pages_read_user_content,pages_manage_posts,pages_manage_engagement,pages_read_engagement,page_events,pages,business_management,${instagramPermission}`;
  if (enableInsiderPermission) {
    scopeString += `,${insiderPermission}`;
  }
  if (target === "WHATSAPP") {
    scopeString += `,${whatsapp}`;
  }

  return scopeString;
};
